<template>
  <div>
    <div v-if="data?.type =='live_youtube'">
      <div v-for="(video, idx) in attachments" :key="idx" class="my-1">
        <TopIframeVideo :src="video?.url" />
      </div>
    </div>
    <div v-else-if="data?.type =='video'">
      <div v-for="(video, idx) in attachments" :key="idx" class="my-1">
        <TopIframeVideo :src="video?.url" />
      </div>
    </div>
    <div v-else-if="data?.type =='photo'">
      <div v-if="photoShowLightbox.length">
        <div class="d-flex flex-wrap no-gutters">
          <div
            v-for="(img, idx) in photoShowLightbox"
            :key="img.id"
            :class="`col-${img.spans}`"
          >
            <el-image
              :src="img.url"
              fit="none"
              :preview-src-list="handlePreView(idx)"
              style="height: 100%; widows: 100%;"
              >
            </el-image>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="data?.type =='article'">
      <div v-for="(article, idx) in attachments" :key="idx" class="my-1">
        <el-card :body-style="{ padding: '0px' }">
          <RatioImage
            v-if="article?.thumbnail"
            ratio="16:9"
            :src="imgProxy(article?.thumbnail)"
            :tip="article?.title"
          />
          <div style="padding: 14px;">
            <div class="card-title h5">{{ article.title }}</div>
            <!-- <div class="text-right font-size-sm text-muted mb-3">
              {{ dateFormat(article?.article?.created_at, "YYYY/MM/DD HH:mm A") }}
            </div> -->
            <div class="font-weight-light mb-5">
              {{ article?.summary }}
            </div>
            
            <div v-html="article?.article?.html_message">
            </div>

            <div class="my-3">
              <a
                v-for="keyword in article?.keywords"
                :key="keyword"
                :href="`${fbmsn_url}/${data?.from?.username}/tags/${encodeURIComponent(keyword)}`"
                target="_blank"
                class="btn btn-outline-secondary btn-sm mr-1"
                >
                #{{ keyword }}
              </a>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    
    <div v-else>
      <!-- 
        type: {{ data?.type }}<br />
        feed_settings: {{ extraContext?.feed_settings }}<br />
        <pre>{{ attachments }}</pre> 
      -->
    </div>
    <!-- <pre>{{ data }}</pre> -->
  </div>
</template>

<script setup>
import { computed, ref, reactive, watch, toRaw } from 'vue';
import TopIframeVideo from '../TopIframeVideo.vue';
import RatioImage from '../RatioImage.vue'

import { 
  notificationErrors, 
  dataTranslations as dt, 
  breakpoint, 
  imgProxy,
  dateFormat,
} from "../../utils";

const props = defineProps({
  data: { type: Object, required: true },
  storeData: { type: Object, required: true },
  distributor: { type: Object, default: () => {} },
  distributorLevels: { type: Array, default: () => [] },
  is_login: { type: Boolean, default: false },
  fbmsn_url: { type: String, default: "https://www.fbmsn.com" },
})

const storeId = computed(() => props.storeData?.follow_store_id || props.storeData?.id)
const storeCurrency = computed(() => props.storeData?.currency || "TWD")
const refStoreId = computed(() => props.storeData?.id)
const isDistribute = computed(() => !!props.distributor?.id)
const attachments = computed(() => props.data?.attachments || [])
const extraContext = computed(() => props.data?.extra_context || null)
const isMobile = computed(() => breakpoint.value.xs)

// 定義前圖片的寬度
const colSpans = [
  6, 6, 
  4, 4, 4,
  3, 6, 3,
  4, 8, 
  3, 3, 3, 3, 
]
const photoShowLightbox = computed(() => {
  // console.debug("type", props.data?.type)
  if (props.data?.type !== "photo") {
    return [];
  }
  let totalSapn = 0
  let medias = props.data.attachments.map((media, idx) => {
    const countIdx = idx >= colSpans.length ? idx % colSpans.length : idx
    let spans = colSpans[countIdx]
    totalSapn += spans
    // console.debug("mod", idx, media)
    return {
      ...media,
      url: imgProxy(media.url),
      spans,
    }
  });
  if (totalSapn % 12) {
    const photoLength = props.data.attachments.length - 1
    medias[photoLength].spans += 12 - totalSapn % 12
    // console.debug("totalSapn", totalSapn, 12 - totalSapn % 12)
  }
  return medias
})

const state = reactive({
})

const handlePreView = (idx) => {
  const list = photoShowLightbox.value.map((el) => el.url)
  if (idx > 0) {
    return [...list.slice(idx), ...list.slice(0, idx)]
  }
  return list
}

// watch(
//   () => props.data,
//   (v) => {
//     if (v?.id) {
//     }
//   },
//   { deep: true, immediate: true }
// )
</script>

<style>
.swal2-container {
  z-index: 3000;
}
.alerts-border {
  border: 3px #f34770 solid;
  animation: blink 1s;
  animation-iteration-count: 3;
}

@keyframes blink { 50% { border-color:#fff ; }  }

</style>
